import { FormProvider } from "react-hook-form";
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import useAuth from "$hooks/useAuth";
import { useProjectFormLogic } from "../hooks/useProjectFormLogic";

type ProjectFormContextType = {
  currentCompany: any;
  currentContact: any;
  currentContactObject: any;
  isAlias: boolean;
  isAdmin: boolean;
  isSubmitting: boolean;
  setIsSubmitting: (value: boolean) => void;
  projectError?: any;
  setProjectError: (error: any) => void;
  project?: any;
  defaultValuesForm?: any;
  handleUserAddClick: () => void;
  handleUserPopinSubmit: (data: any) => void;
  openUser: boolean;
  toggleUserPopin: (isOpen: boolean) => void;
  onAddClick: () => void;
  setTitle: (title: string) => void;
  onUserSubmit: (data: any) => Promise<any>;
  onUserSubmitEdit: (data: any) => Promise<any>;
  errorUser: string;
};

export const ProjectFormContext = createContext<
  ProjectFormContextType | undefined
>(undefined);

export const useProjectForm = () => {
  const context = useContext(ProjectFormContext);
  if (context === undefined) {
    throw new Error("useProjectForm must be used within ProjectFormProvider");
  }
  return context;
};

type ProjectFormProviderProps = {
  children: React.ReactNode;
  project?: any;
  projectError?: any;
  defaultValuesForm?: any;
  isSubmitting?: boolean;
};

export const ProjectFormProvider: React.FC<ProjectFormProviderProps> = ({
  children,
  project,
  projectError: initialProjectError,
  isSubmitting: initialIsSubmitting = false,
  defaultValuesForm,
}) => {
  const { isAdmin } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(initialIsSubmitting);
  const [projectError, setProjectError] = useState(initialProjectError);

  useEffect(() => {
    setProjectError(initialProjectError);
  }, [initialProjectError]);

  const {
    form,
    currentCompany,
    currentContact,
    currentContactObject,
    isAlias,
    handleUserAddClick,
    handleUserPopinSubmit,

    // user form

    onAddClick,
    openUser,
    toggleUserPopin,
    onUserSubmit,
    onUserSubmitEdit,
    errorUser,
    setTitle,
  } = useProjectFormLogic(project, defaultValuesForm);

  const value = useMemo(
    () => ({
      currentCompany,
      currentContact,
      currentContactObject,
      isAlias,
      isAdmin,
      isSubmitting,
      setIsSubmitting,
      projectError,
      setProjectError,
      project,
      defaultValuesForm,
      handleUserAddClick,
      handleUserPopinSubmit,

      /*  user form */

      onAddClick,
      openUser,
      toggleUserPopin,
      onUserSubmit,
      onUserSubmitEdit,
      errorUser,
      setTitle,
    }),
    [
      currentCompany,
      currentContact,
      currentContactObject,
      isAlias,
      isAdmin,
      isSubmitting,
      projectError,
      project,
      defaultValuesForm,
      handleUserAddClick,
      handleUserPopinSubmit,

      onAddClick,
      openUser,
      toggleUserPopin,
      onUserSubmit,
      onUserSubmitEdit,
      errorUser,
      setTitle,
    ]
  );

  return (
    <ProjectFormContext.Provider value={value}>
      <FormProvider {...form}>{children}</FormProvider>
    </ProjectFormContext.Provider>
  );
};
